import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforWeighBridge {
  activePage:string
}

@Module({ dynamic: true, store, name: 'store_scanforweighbridge' })
class ScanforWeighBridge extends VuexModule implements IScanforWeighBridge {
  public activePage = "item";

  @Mutation
  public setActivePage(str) {
    this.activePage = str;
  }
}

export const ScanforWeighBridgeModule = getModule(ScanforWeighBridge)
